/** @format */

export interface CCAddressV2 {
  address: string;
  city: string;
  country: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  state: string;
  zipcode: string;
}
